module.exports = __webpack_public_path__ + "img/56_69.1384a43e.png";